/**
 * Shared Framer Motion animation variants used across pages.
 * Extract inline objects to avoid re-creation on every render.
 */

// Common entrance animations
export const fadeInUp = { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 } };
export const fadeInUpLarge = { initial: { opacity: 0, y: 30 }, animate: { opacity: 1, y: 0 } };
export const fadeInLeft = { initial: { opacity: 0, x: -20 }, animate: { opacity: 1, x: 0 } };
export const fadeInRight = { initial: { opacity: 0, x: 20 }, animate: { opacity: 1, x: 0 } };
export const fadeInScale = { initial: { opacity: 0, scale: 0.95 }, animate: { opacity: 1, scale: 1 } };

// Staggered container
export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
};
export const staggerItem = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

// Transition presets
export const springTransition = { type: 'spring', stiffness: 100 };
export const defaultTransition = { duration: 0.5 };
